import { IKeyStrategy } from '../key-strategy.interface'

const SEPARATOR = '::'

export class PrefixKeyStrategy implements IKeyStrategy {
  constructor(private _prefix: string) {}

  public getKey(key: string): string {
    return `${this._prefixString}${key}${SEPARATOR}`
  }

  public isKey(key: any): boolean {
    if (typeof key !== 'string') { return false }

    return key.startsWith(this._prefixString) && key.endsWith(SEPARATOR)
  }

  private get _prefixString() {
    return `${this._prefix}${SEPARATOR}`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/analytics-data-provider/prefix-key-strategy/prefix-key-strategy.ts